import React from "react";
import {Link, useI18next} from 'gatsby-plugin-react-i18next';
import {graphql, useStaticQuery} from "gatsby";
import styled from 'styled-components';

const Switcher = styled.div`
  --lang-color: var(--header-items-color, var(--bs-linen));
  --lang-hover-color: var(--header-lang-hover-bg, var(--bs-linen));
  --lang-bg: var(--header-items-bg, var(--bs-primary));
  --lang-drop-color: var(--bs-forest-green);

  width: 40px;
  height: 40px;
  font: 400 18px/1.1 var(--bs-cubano-font-family);
  text-transform: uppercase;
  color: var(--lang-color);
  background: var(--lang-bg);
  letter-spacing: 0.02em;
  @media (min-width: 640px) {
    width: 50px;
    height: 50px;
  }
  &:hover{
    ul{
      transform: scaleY(1);
      transition-delay: 0s;
      li{
        opacity: 1;
        transition-delay: 0.15s;
      }
    }
  }
  ul{
    background: var(--lang-bg);
    padding: 10px 0 0;
    margin-top: -10px;
    transition: .25s ease-out;
    transition-property: transform;
    transform: scaleY(0);
    transform-origin: 50% 0;
    transition-delay: 0.15s;
    li{
      padding: 0 3px 3px;
      transition: .15s ease-out;
      transition-property: opacity;
      opacity: 0;
      transition-delay: 0s;
      &:before{
        content: '';
        width: 12px;
        height: 1px;
        background: var(--lang-hover-color);
        display: block;
        margin: 0 auto;
      }
    }
    a{
      text-align: center;
      //border-radius: 8px;
      display: block;
      color: var(--lang-drop-color);
      padding: 5px 6px;
      margin: 3px 0 0;
      font:inherit;
      text-transform: uppercase;
      @media (min-width: 640px) {
        padding-top: 8px;
        padding-bottom: 8px;
      }
      &:hover{
        background: var(--lang-hover-color);
      }
    }
  }
`

const LangSwitcher = ({translations}) => {
  let slug = (translations?.length > 0 && translations[0]?.slug) || '';
  const isFrontPage = (translations?.length > 0 && translations[0]?.isFrontPage) || false;
  slug = isFrontPage ? '' : slug;

  const {language} = useI18next();

  const { wp } = useStaticQuery(graphql`
		query {
			wp {
        languages {
          name
          slug
          locale
        }
      }
		}
	`);
  const wpLangs = (wp.languages || []).sort((a, b) => a.slug.localeCompare(b.slug));

  return wpLangs?.length > 0 && (
    <Switcher className="position-relative p-6 d-flex align-items-center justify-content-center pe-auto">
      <span>{language}</span>
      {translations?.length > 0 && (
        <ul className="list-unstyled position-absolute top-100 start-0 w-100">
          {wpLangs.map((lng, index) => (
            lng.slug !== language &&
            translations.some((translation) => translation?.language?.slug === lng.slug )
          ) ? (
            <li key={index + lng}>
              <Link to={`/${slug}`} language={lng.slug}>
                {lng.slug.toUpperCase()}
              </Link>
            </li>
          ): null )}
        </ul>
      )}
    </Switcher>
  )
}

export default LangSwitcher
